import type {
  StatusInventoryListingConfig,
  statusOptionsLabels,
  statusOptionsValues
} from "@dealer-center/ddc-pages-inventory-config-interface";
import {
  statusOptionsGetValue,
  statusOptionsLabelsList
} from "@dealer-center/ddc-pages-inventory-config-interface";
import type { baseInputs } from "./base";

type statusListFlat = Record<statusListType, statusInputs>;
export type statusListType = keyof StatusInventoryListingConfig;
export interface statusInputs extends baseInputs {
  type: "status";
  default: number[];
  options: { label: statusOptionsLabels; value: statusOptionsValues }[];
}
export const statusListFlat: statusListFlat = {
  statusList: {
    type: "status",
    dataIndex: "statusList",
    label: "Status",
    default: [],
    options: statusOptionsLabelsList.slice(1).map(status => {
      return { label: status, value: statusOptionsGetValue(status) };
    })
  }
};

export const isStatus = (input: baseInputs): input is statusInputs =>
  input.type === "status";

// all should auto select all
// <input type="checkbox" name="status_all" style="margin-bottom:10px;" onclick="window['inventoryConfigBlockJS'].handleStatusChange([]);">&nbsp; All (default value)<br>
// <input type="checkbox" name="status_live" style="margin-bottom:5px;" class="status_class" value="1" disabled="">&nbsp; Live<br>
// <input type="checkbox" name="status_sold" style="margin-bottom:5px;" class="status_class" value="5" disabled="">&nbsp; Sold<br>
// <input type="checkbox" name="status_staging" style="margin-bottom:5px;" class="status_class" value="3" disabled="">&nbsp; Staging<br>
// <input type="checkbox" name="status_rejected" style="margin-bottom:5px;" class="status_class" value="9" disabled="">&nbsp; Rejected<br>
// <input type="checkbox" name="status_onDeposit" style="margin-bottom:5px;" class="status_class" value="10" disabled="">&nbsp; On Deposit<br>
// <input type="checkbox" name="status_inTransit" style="margin-bottom:5px;" class="status_class" value="7" disabled="">&nbsp; In Transit<br>
// <input type="checkbox" name="status_inTransitSold" style="margin-bottom:5px;" class="status_class" value="12" disabled="">&nbsp; In Transit Sold<br>
// <input type="checkbox" name="status_inTransitAtPort" style="margin-bottom:5px;" class="status_class" value="11" disabled="">&nbsp; In Transit At Port<br>
// <input type="checkbox" name="status_inTransitAtFactory" style="margin-bottom:5px;" class="status_class" value="13" disabled="">&nbsp; In Transit At Factory

//   #  ALL_TYPES = 0;
// #  int LIVE = 1;
// #  int STAGING = 3;
// #  int SOLD = 5;
// #  int IN_TRANSIT = 7;
// #  int REJECTED = 9;
// #  int ON_DEPOSIT = 10;
// #  int IN_TRANSIT_AT_PORT = 11;
// #  int IN_TRANSIT_SOLD = 12;
// #  int IN_TRANSIT_AT_FACTORY = 13;
// #  int PENDING_APPROVAL  = 14
